export const PREVIEW_ZOOM_STORAGE_KEY = "preview-zoom"

export const PREVIEW_HOT_RELOAD_STORAGE_KEY = "preview-hot-reload"

export const PREVIEW_IGNORED_ERRORS_STORAGE_KEY = "preview-ignored-errors"

export const PREVIEW_DEVICE_MODE_STORAGE_KEY = "preview-device-mode"
export const PREVIEW_DEVICE_TYPE_STORAGE_KEY = "preview-device-type"
